import {apiClient} from "../utils/Api";

export default class CarBrandService {

    static getDetail = (id) => {
        return apiClient.get(`/car-brand/detail?id=`+id);
    };

    static getList = () => {
        return apiClient.get(`/car-brand/list`);
    };
}